import { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router';

const FiscalReport = () => {
  const history = useHistory();

  const match = useRouteMatch();

  useEffect(() => {
    if (match.isExact) {
      history.replace(`/app/reports/fiscalReport/invoice`);
    }
  }, [match]);

  return null;
};

export default FiscalReport;
